<template>
	<v-dialog :value="show" persistent width="300">
		<v-card color="white" light>
			<v-card-text>
				{{ message }}
				<v-progress-linear indeterminate color="primary" class="mb-0" />
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: {
			message: {
				default: ''
			},
			show: {
				required: true,
				default: false
			}
		}
	};
</script>